import { render, staticRenderFns } from "./AggiornaRischio.vue?vue&type=template&id=49238477&scoped=true&"
import script from "./AggiornaRischio.vue?vue&type=script&lang=js&"
export * from "./AggiornaRischio.vue?vue&type=script&lang=js&"
import style0 from "./AggiornaRischio.vue?vue&type=style&index=0&id=49238477&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49238477",
  null
  
)

export default component.exports